<template>
  <div class="PaymentReport">
    <h3 class="mb-3 text-right">Reporte de deposito</h3>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              Reportes de deposito a la cuenta de Cuenta de liquidez
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text >
        <b-tabs content-class="mt-3" >
          <b-tab title="Nuevo reporte de deposito" active>
              <Create />
          </b-tab>
          <b-tab title="Reportes realizados">
            <All />
          </b-tab>
        </b-tabs>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import Create from "../components/PaymentReports/Create"
import All from "../components/PaymentReports/All"

export default {
    name: 'PaymentReport',
    components:{
        Create,
        All
    }
}
</script>
<style scoped>
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
a {
  color: #CF173C !important;
}
</style>